// Motivational quote of the day for the login screen.
//
// CEO 13/09/2026 (9a): tone is down-to-earth, colleague-to-colleague, tied to
// real studio situations — no slogans, no emoji, no money talk. Everyone sees
// the same quote on the same calendar day; it rotates daily with no server
// call. To add/remove a quote, edit QUOTES only.
export const QUOTES = [
  "Sáng nay chưa tỉnh cũng không sao. Cà phê xong, làm từng việc một là ổn.",
  "Khách khó tính hôm nay có thể là người khen mình nhiệt tình nhất tuần sau. Cứ tử tế trước đã.",
  "Không cần hoàn hảo ngay. Làm xong, làm đúng, rồi mới làm đẹp.",
  "Tấm ảnh khách khoe với gia đình tối nay là do tay mình hôm nay. Nghĩ vậy cho vui.",
  "Việc nhỏ làm kỹ thì không ai phải làm lại. Đó là cách đỡ mệt nhất cho cả team.",
  "Chưa rõ thì hỏi luôn. Hỏi mất 10 giây, đỡ sửa mất 1 tiếng.",
  "Đồng đội đang rối thì đỡ một tay. Mai mình rối, họ đỡ lại.",
  "Nụ cười ở quầy đôi khi ghi điểm với khách hơn cả concept.",
  "Sai thì nhận, sửa nhanh, rồi bỏ qua. Không ai giỏi lên nhờ tự trách cả ngày.",
  "Tan ca thì tắt việc, nghỉ cho đàng hoàng. Mai còn chiến tiếp.",
  "Khách nhớ cách mình đối xử với họ lâu hơn nhớ mình nói gì.",
  "Hôm nay làm được một việc khiến mình tự hào là ngày đó không phí.",
  "Chụp ảnh là làm cho người ta thấy mình đẹp hơn cả lúc tự soi gương. Nghề mình hay ở chỗ đó.",
  "Đừng đợi có hứng mới làm tốt. Làm tốt xong, hứng tự đến.",
] as const;

export type Quote = (typeof QUOTES)[number];

const MS_PER_DAY = 86_400_000;

/**
 * Whole days since the Unix epoch for the LOCAL calendar date of `d`.
 * Built from local Y/M/D through Date.UTC so DST or timezone offsets can
 * never make two consecutive days collapse into one (or skip one).
 */
export function dayNumber(d: Date): number {
  return Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / MS_PER_DAY);
}

/** Quote shown to everyone on the calendar day of `d` (defaults to today). */
export function quoteOfTheDay(d: Date = new Date()): Quote {
  return QUOTES[dayNumber(d) % QUOTES.length] ?? QUOTES[0];
}
